export const environment = {
  production: true,
  apiBaseLink: 'https://api.myescort.dk',
  userBaseUrl: '/account/profile',
  userLoginUrl: '/login',
  VERSION: 1,
};
